// Peek comparison chart — sections/peek-comparison.liquid
// Below 1100px: prev/next arrows for the sideways scroller. At all widths: a pinned
// row of product names once the product headers leave the screen (it follows the
// sideways scroll on mobile).

if (!customElements.get("peek-compare")) {
  customElements.define(
    "peek-compare",
    class PeekCompare extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector("[data-scroller]");
        this.prevButton = this.querySelector("[data-prev]");
        this.nextButton = this.querySelector("[data-next]");
        this.sticky = this.querySelector("[data-sticky]");
        this.stickyTrack = this.querySelector("[data-sticky-track]");
        this.head = this.querySelector("[data-head]");

        this.onScroll = () => this.update();
        this.scroller.addEventListener("scroll", this.onScroll, {
          passive: true,
        });
        window.addEventListener("resize", this.onScroll);
        this.prevButton.addEventListener("click", () => this.step(-1));
        this.nextButton.addEventListener("click", () => this.step(1));

        // Show the names once the product headers scroll off the top, and slide the
        // theme header away meanwhile so the two don't overlap (see the CSS).
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.sticky.classList.toggle("is-visible", scrolledPast);
          document.documentElement.classList.toggle(
            "peek-compare-hide-header",
            scrolledPast,
          );
        });
        this.observer.observe(this.head);

        this.update();
      }

      disconnectedCallback() {
        this.scroller.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onScroll);
        this.observer.disconnect();
        document.documentElement.classList.remove("peek-compare-hide-header");
      }

      step(direction) {
        const column = this.querySelector("[data-col]");
        const gap =
          parseFloat(getComputedStyle(this).getPropertyValue("--pc-gap")) || 0;
        this.scroller.scrollBy({
          left: direction * (column.offsetWidth + gap),
          behavior: "smooth",
        });
      }

      update() {
        const x = this.scroller.scrollLeft;
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        this.stickyTrack.style.transform = `translateX(${-x}px)`;
        this.prevButton.disabled = x <= 1;
        this.nextButton.disabled = x >= max - 1;
      }
    },
  );
}
